import axios from '@/utilities/axios-global'

function buildReviewDashboardRequestBody(payload, recordType) {
  const recordTypeScopeKeyMap = {
    ip: 'selectedAccountNumbersIP',
    op: 'selectedAccountNumbersOP',
    amb: 'selectedAccountNumbersAMB',
    pro: 'selectedAccountNumbersPRO'
  }

  return {
    projects: payload.projects,
    selectedAccountNumbers: payload.selectedAccountNumbers || payload[recordTypeScopeKeyMap[recordType]] || null
  }
}

export function GET_DASHBOARD(context, payload) {
  const currentlyPending = payload.currentlyPending == null ? true : payload.currentlyPending
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/${payload.startDate}/${payload.endDate}?currentlyPending=${currentlyPending}`).then(
      response => {
        context.commit('SET_DASHBOARD', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_PENDINGLIST_STATISTICS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/${payload.startDate}/${payload.endDate}/coding/pendinglist?currentlyPending=${payload.currentlyPending}`).then(
      response => {
        context.commit('SET_PENDINGLIST_STATISTICS', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_PROJECTS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/projects/review/${payload.startDate}/${payload.endDate}`).then(
      response => {
        context.commit('SET_DASHBOARD_PROJECTS', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_DASHBOARD_PROJECTS_MULTIPLE(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/projectsmultiple/review/${payload.startDate}/${payload.endDate}`, payload.subClients).then(
      response => {
        context.commit('SET_DASHBOARD_PROJECTS', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_PROJECTS_CODING(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/dashboard/projects/coding/${payload.startDate}/${payload.endDate}${payload.initialProjectId ? `?initialProjectId=${payload.initialProjectId}` : ''}`
    axios.get(url).then(
      response => {
        context.commit('SET_DASHBOARD_PROJECTS_CODING', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_REVIEW_DASHBOARD_ALL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('POST_REVIEW_DASHBOARD_IP', payload), context.dispatch('POST_REVIEW_DASHBOARD_OP', payload), context.dispatch('POST_REVIEW_DASHBOARD_PRO', payload), context.dispatch('POST_REVIEW_DASHBOARD_AMB', payload)]).then(
      axios.spread((ipResponse, opResponse, proResponse, ambResponse) => {
        let respData = []
        respData = ipResponse.data.concat(opResponse.data, proResponse.data, ambResponse.data)
        context.commit('SET_REVIEW_DASHBOARD', respData)
        resolve(true)
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_REVIEW_DASHBOARD_IP(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/review/${payload.startDate}/${payload.endDate}/ip?grouping=${payload.inpatientGrouping}`, buildReviewDashboardRequestBody(payload, 'ip')).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_REVIEW_DASHBOARD_OP(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/review/${payload.startDate}/${payload.endDate}/op?grouping=${payload.outpatientGrouping}`, buildReviewDashboardRequestBody(payload, 'op')).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_REVIEW_DASHBOARD_AMB(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/review/${payload.startDate}/${payload.endDate}/amb?grouping=${payload.ambulatoryGrouping}`, buildReviewDashboardRequestBody(payload, 'amb')).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_REVIEW_DASHBOARD_PRO(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/review/${payload.startDate}/${payload.endDate}/pro?grouping=${payload.proGrouping}`, buildReviewDashboardRequestBody(payload, 'pro')).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_INTERIM_SUMMARY_PDF_URL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/review/interimsummarybuilder?startDate=${payload.startDate}&endDate=${payload.endDate}&projectId=${payload.projectId}`).then(
      response => {
        const fileUrl = encodeURIComponent(`${context.rootState.user.baseApiUrl}${response.data}`)
        resolve(fileUrl)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_ACCOUNTS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/accounts/${payload.reviewType}`, { accountNumbers: payload.accountNumbers }).then(
      response => {
        context.commit('SET_DASHBOARD_ACCOUNTS', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_ACCOUNTS_FINALIZED(context, payload) {
  return new Promise((resolve, reject) => {
    const url = context.rootState.user.baseApiUrl + `/dashboard/finalaccounts/${payload.startDate}/${payload.endDate}`
    axios.get(url).then(
      response => {
        context.commit('SET_DASHBOARD_ACCOUNTS', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DX_DASHBOARD_BY_HCC(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/dx-by-hcc/${payload.reviewType}?hcc=${payload.hcc}&hccVersion=${payload.hccVersion}`, { accountNumbers: payload.accountNumbers }).then(
      response => {
        context.commit('SET_DX_MODAL_DATA', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_WORKSHEET(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/worksheet/${payload.reviewType}/${payload.id}`).then(
      response => {
        context.commit('SET_WORKSHEET', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_WORKSHEET_PDF_URL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/worksheetbuilder/${payload.reviewType}/${payload.id}`).then(
      response => {
        const fileUrl = encodeURIComponent(`${context.rootState.user.baseApiUrl}${response.data}`)
        resolve(fileUrl)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_SCHEDULE(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/codingSchedule/${payload.projectId}`).then(
      response => {
        context.commit('SET_SCHEDULE', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_SCHEDULE_PDF_URL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/codingSchedulePdfBuilder/${payload.projectId}`).then(
      response => {
        const fileUrl = encodeURIComponent(`${context.rootState.user.baseApiUrl}${response.data}`)
        resolve(fileUrl)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_CALENDAR_SCHEDULE(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/codingCalendarSchedule/${payload.projectId}`).then(
      response => {
        context.commit('SET_CALEDNAR_SCHEDULE', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_CODINGLOGLIST(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/dashboard/coding/codinglogs?startDate=${payload.startDate}&endDate=${payload.endDate}`
    axios.get(url).then(
      response => {
        context.commit('SET_CODINGLOGLIST', response.data)
        resolve(response.data)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_IP(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/comparisonaccounts/ip?grouping=${payload.grouping}`, payload).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_OP(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/comparisonaccounts/op?grouping=${payload.grouping}`, payload).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/comparisonaccounts/amb?grouping=${payload.grouping}`, payload).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_PRO(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/comparisonaccounts/pro?grouping=${payload.grouping}`, payload).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_CODINGLOG_PDF_URL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/coding/codingLogsBuilder?consultantNumber=${payload.consultantNumber}&serviceType=${payload.serviceType}&date=${payload.date}`).then(
      response => {
        const fileUrl = encodeURIComponent(`${context.rootState.user.baseApiUrl}${response.data}`)
        resolve(fileUrl)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_CODINGLOG(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/coding/codinglogs/${payload.consultantNumber}/${payload.serviceType}/${payload.date}`).then(
      response => {
        context.commit('SET_CODINGLOG', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_CODINGSUMMARY_PDF_URL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/coding/codingsummarybuilder?startDate=${payload.startDate}&endDate=${payload.endDate}`).then(
      response => {
        const fileUrl = encodeURIComponent(`${context.rootState.user.baseApiUrl}${response.data}`)
        resolve(fileUrl)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_CODINGSUMMARY(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/dashboard/coding/codingsummary?startDate=${payload.startDate}&endDate=${payload.endDate}`).then(
      response => {
        resolve(response.data)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_CODINGLOG_ZIP(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/dashboard/coding/codinglogs/builder`, payload.logs).then(
      response => {
        // context.commit('SET_CODINGLOG', response.data)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_ALL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('GET_DASHBOARD_COMPARISON_ACCOUNTS_IP', payload)]).then(
      axios.spread(respData => {
        if (!payload.noMutation) {
          context.commit('SET_DASHBOARD_COMPARISON_ACCOUNTS', respData.data)
          resolve(true)
        } else {
          resolve(respData)
        }
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_BEDSIZE(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('GET_DASHBOARD_COMPARISON_ACCOUNTS_IP', payload)]).then(
      axios.spread(respData => {
        if (!payload.noMutation) {
          context.commit('SET_DASHBOARD_COMPARISON_ACCOUNTS_BEDSIZE', respData.data)
          resolve(true)
        } else {
          resolve(respData)
        }
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_OP_ALL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('GET_DASHBOARD_COMPARISON_ACCOUNTS_OP', payload)]).then(
      axios.spread(respData => {
        if (!payload.noMutation) {
          context.commit('SET_DASHBOARD_COMPARISON_ACCOUNTS_OP', respData.data)
          resolve(true)
        } else {
          resolve(respData)
        }
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_OP_BEDSIZE(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('GET_DASHBOARD_COMPARISON_ACCOUNTS_OP', payload)]).then(
      axios.spread(respData => {
        if (!payload.noMutation) {
          context.commit('SET_DASHBOARD_COMPARISON_ACCOUNTS_OP_BEDSIZE', respData.data)
          resolve(true)
        } else {
          resolve(respData)
        }
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_ALL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB', payload)]).then(
      axios.spread(respData => {
        if (!payload.noMutation) {
          context.commit('SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB', respData.data)
          resolve(true)
        } else {
          resolve(respData)
        }
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB', payload)]).then(
      axios.spread(respData => {
        if (!payload.noMutation) {
          context.commit('SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE', respData.data)
          resolve(true)
        } else {
          resolve(respData)
        }
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function GET_DASHBOARD_COMPARISON_ACCOUNTS_PRO_ALL(context, payload) {
  return new Promise((resolve, reject) => {
    axios.all([context.dispatch('GET_DASHBOARD_COMPARISON_ACCOUNTS_PRO', payload)]).then(
      axios.spread(respData => {
        if (!payload.noMutation) {
          context.commit('SET_DASHBOARD_COMPARISON_ACCOUNTS_PRO', respData.data)
          resolve(true)
        } else {
          resolve(respData)
        }
      }),
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_FILTER_ACCOUNTS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + '/dashboard/accounts/filter', payload).then(
      response => {
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export default {
  GET_DASHBOARD,
  GET_PENDINGLIST_STATISTICS,
  GET_DASHBOARD_PROJECTS,
  GET_DASHBOARD_PROJECTS_CODING,
  POST_DASHBOARD_PROJECTS_MULTIPLE,
  POST_REVIEW_DASHBOARD_ALL,
  POST_REVIEW_DASHBOARD_IP,
  POST_REVIEW_DASHBOARD_OP,
  POST_REVIEW_DASHBOARD_AMB,
  POST_REVIEW_DASHBOARD_PRO,
  GET_DASHBOARD_ACCOUNTS,
  GET_DASHBOARD_ACCOUNTS_FINALIZED,
  GET_WORKSHEET,
  GET_WORKSHEET_PDF_URL,
  GET_SCHEDULE_PDF_URL,
  GET_SCHEDULE,
  GET_CODINGLOGLIST,
  GET_CODINGLOG,
  GET_CODINGLOG_ZIP,
  GET_CODINGLOG_PDF_URL,
  GET_CODINGSUMMARY,
  GET_CODINGSUMMARY_PDF_URL,
  // GET_DASHBOARD_COMPARISON_ACCOUNTS,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_ALL,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_BEDSIZE,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_OP_ALL,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_OP_BEDSIZE,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_PRO_ALL,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_ALL,
  GET_CALENDAR_SCHEDULE,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_IP,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_OP,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_AMB,
  GET_DASHBOARD_COMPARISON_ACCOUNTS_PRO,
  GET_INTERIM_SUMMARY_PDF_URL,
  GET_DX_DASHBOARD_BY_HCC,
  POST_FILTER_ACCOUNTS
}
